import React from "react";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { useContext } from "react";
import Recipe from "./pages/Recipe";
import Search from "./pages/Search";
import SideBarLayout from "./layout/SideBarLayout";

const queryClient = new QueryClient();

function AppRoutes() {
  const { isLogged } = useContext(AuthContext);

  return (
    <Routes>
      <Route path="/" element={isLogged ? <Home /> : <Login />} />
      <Route path="/login" element={isLogged ? <Navigate to="/" /> : <Login />} />
      <Route path="/register" element={isLogged ? <Navigate to="/" /> : <Register />} />
      <Route path="/recipe/:id" element={<Recipe />} />
      <Route
        path="/search/:keyword/:mealType"
        element={
          <SideBarLayout>
            <Search />
          </SideBarLayout>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
